import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, User, Shield, MapPin, Award, Settings, ChevronRight } from 'lucide-react';
import '../styles/global.css';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Mock User Data
  const userData = {
    name: user?.name || "Citizen #4092",
    email: user?.email || "user@stakestreet.ai", // Updated Email domain
    role: "Verified Reporter",
    joined: "Oct 2024",
    reports: 42,
    reputation: 850,
    tokens: 120
  };

  return (
    <div className="container" style={{ paddingTop: '100px', maxWidth: '600px', margin: '0 auto', paddingBottom: '40px' }}>
      
      {/* 1. Profile Header Card */}
      <div className="glass-panel" style={{ padding: '30px', textAlign: 'center', marginBottom: '25px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position:'absolute', top:'-50px', left:'-50px', width:'150px', height:'150px', background:'var(--primary)', opacity:'0.1', borderRadius:'50%', filter:'blur(40px)' }}></div>

        <div style={{ width: '100px', height: '100px', background: 'var(--glass-border)', borderRadius: '50%', margin: '0 auto 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid var(--primary)' }}>
          <User size={50} color="var(--primary)" />
        </div>
        
        <h1 style={{ fontSize: '1.8rem', marginBottom: '5px' }}>{userData.name}</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
          <Shield size={14} color="#8b5cf6" /> {userData.role}
        </p>

        {/* Quick Stats Row */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '25px', borderTop: '1px solid var(--glass-border)', paddingTop: '20px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{userData.reports}</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Reports</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#8b5cf6' }}>{userData.reputation}</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Reputation</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#f59e0b' }}>{userData.tokens}</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>$GUARD</div>
          </div>
        </div>
      </div>

      {/* 2. Menu Options */}
      <div className="glass-panel" style={{ padding: '10px', marginBottom: '25px' }}>
        <MenuItem icon={User} label="Personal Details" value={userData.email} />
        <MenuItem icon={MapPin} label="Saved Locations" />
        <MenuItem icon={Award} label="Achievements" />
        <MenuItem icon={Settings} label="App Settings" />
      </div>

      {/* 3. Sign Out Button */}
      <button 
        onClick={handleLogout}
        className="glass-btn" 
        style={{ 
          width: '100%', padding: '15px', color: '#ef4444', borderColor: 'rgba(239, 68, 68, 0.3)', 
          background: 'rgba(239, 68, 68, 0.05)', fontWeight: '600', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px'
        }}
      >
        <LogOut size={20} /> Sign Out
      </button>

      <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
        StakeStreet v1.0 • Monad Testnet
      </p>

    </div>
  );
};

// Helper Component for Menu Items
const MenuItem = ({ icon: Icon, label, value }) => (
  <div style={{ 
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
    padding: '16px', borderBottom: '1px solid var(--glass-border)', cursor: 'pointer', transition: 'background 0.2s' 
  }} className="menu-item">
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Icon size={20} color="var(--text-muted)" />
      <span style={{ fontSize: '1rem' }}>{label}</span>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--text-muted)' }}>
      {value && <span style={{ fontSize: '0.9rem' }}>{value}</span>}
      <ChevronRight size={16} />
    </div>
  </div>
);

export default Profile;